import CryptoJS from "crypto-js";

export const decryptId = (encryptedId, secretKey) => {
  try {
    const bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedId), secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    if (!decrypted) throw new Error("Failed to decrypt or empty result");
    return JSON.parse(decrypted);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};
